import { Status } from "../Config/Status.js";
import { Options } from "../Config/Options.js";

const Animation = {
  dom : document.querySelectorAll('.js-anime:not(.' + Options.actAnime + ')'),
  options: {
    rootMargin: "-15% 0px",
    threshold: 0,
  },
  init() {
    this.observerAnime();
  },

  observerAnime() {
    let observer = new IntersectionObserver(this.observerCallbackAnime, this.options);
    this.dom.forEach((target) => {
      if (target.dataset.delay) {
        target.style.transitionDelay = target.dataset.delay + 'ms';
      }
      observer.observe(target);
    });
  },
  observerCallbackAnime(entries, object) {
    entries.forEach(function (entry, i) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add(Options.actAnime);
      object.unobserve(entry.target);
    });
  },
}

export default Animation;